<div class="merchandise-group">
    <div class="title">
        <h2>{{ merchandiseData.title }}</h2>
        <finder-polyline *ngIf="merchandiseData.polyline || merchandiseData.mobilePolyline"
            [polyline]="merchandiseData.polyline"
            [mobilePolyline]="merchandiseData.mobilePolyline">
        </finder-polyline>
    </div>
    <h3 class="subtitle" *ngIf="merchandiseData.subtitle">{{ merchandiseData.subtitle }}</h3>
    <div class="merchandise-wrapper">
        <finder-anchor class="merchandise"
            *ngFor="let merchandiseItem of merchandiseData.merchandise | slice:0:limit"
            [ariaLabel]="merchandiseItem.title"
            [href]="merchandiseItem.href">
                <finder-picture class="image fit"
                    [picture]="merchandiseItem.picture">
                </finder-picture>
                <div class="merchandise-detail">
                    <h4 class="merchandise-title" [innerHTML]="merchandiseItem.title | safeHtml"></h4>
                    <p *ngIf="merchandiseItem.subtitle" [innerHTML]="merchandiseItem.subtitle | safeHtml"></p>
                </div>
        </finder-anchor>
    </div>
    <finder-reveal-content class="reveal-content" *ngIf="merchandiseCount > minimumLength"
        (currentState)="revealContent($event)"
        [showMoreText]="showMoreText"
        [showLessText]="showLessText">
    </finder-reveal-content>
</div>
